import { useRef } from 'react';

import { CheckboxInput } from '@/core/tamagoshi/CheckerInput/CheckboxInput';
import { useProductBundle } from '@/domains/productDiscovery/Recommendation/modules/ProductBundle/context/ProductBundle/ProductBundle.context';
import { EProductBundleActionTypes } from '@/domains/productDiscovery/Recommendation/modules/ProductBundle/context/ProductBundle/productBundle.interfaces';

import type { IOutlineBundleCheckboxProps } from './OutlineBundleCheckbox.interfaces';
import {
  checkboxClickedTranslation,
  checkboxUnclickedTranslation,
} from './OutlineBundleCheckbox.translations';

import styles from './outlineBundleCheckbox.module.scss';

const OutlineBundleCheckbox = ({
  modelId,
  isInBundle,
}: IOutlineBundleCheckboxProps) => {
  const { productBundleDispatch } = useProductBundle();
  const checkboxRef = useRef<HTMLInputElement>(null);

  const checkboxClickHandler = () => {
    productBundleDispatch({
      payload: modelId,
      type: checkboxRef.current?.checked
        ? EProductBundleActionTypes.ADD_PRODUCT
        : EProductBundleActionTypes.REMOVE_PRODUCT,
    });
  };

  return (
    <div className={styles.checkboxWrapper}>
      <CheckboxInput
        ref={checkboxRef}
        className={styles.checkbox}
        testId="outline-bundle-product-list-checkbox"
        key={`outline-product-bundle-checkbox-${modelId}`}
        id={`outline-product-bundle-checkbox-${modelId}`}
        value={`outline-product-bundle-checkbox-value-${modelId}`}
        isChecked={isInBundle}
        onClick={checkboxClickHandler}
      />
      <label
        data-testid="outline-bundle-product-list-checkbox-label"
        htmlFor={`outline-product-bundle-checkbox-${modelId}`}
        className={styles.checkboxLabel}
      >
        {isInBundle ? checkboxClickedTranslation : checkboxUnclickedTranslation}
      </label>
    </div>
  );
};

OutlineBundleCheckbox.displayName = 'OutlineBundleCheckbox';

export default OutlineBundleCheckbox;
